/** A filter item's value as a list of non-blank strings — `isAnyOf` sends an array, the rest a scalar. */
export function asStringArray(value: unknown): string[] {
    if (value === undefined || value === null || value === '') return [];
    if (Array.isArray(value)) return value.map(String).filter(Boolean);
    return [String(value)].filter(Boolean);
}

/** A numeric filter item's value, or `undefined` while the input is empty or not a number yet. */
export function asNumber(value: unknown): number | undefined {
    if (value === undefined || value === null || value === '') return undefined;
    const number = Number(value);
    return Number.isFinite(number) ? number : undefined;
}
